/* istanbul ignore file */
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BlockRegistrationDomainParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('block')],
    ['id', codecString],
    ['domain', codecString],
    ['matchSubdomains', codecBoolean, 'match_subdomains'],
]);
export class BlockRegistrationDomain extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BlockRegistrationDomainParser.decode(input).map(res => new BlockRegistrationDomain(res));
    }
    static unsafeDecode(input) {
        return BlockRegistrationDomain.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BlockRegistrationDomainParser.encode(data);
    }
    static schema() {
        return BlockRegistrationDomainParser.schema();
    }
}
